// extracted by mini-css-extract-plugin
export default {"copyButton":"copyButton---LnADm","copied":"copied---xPgeF"};